import { RiskRange, RiskRanges } from "../ranges";
import { Risk } from "../units";

function rangesFor({ age }: { age: number }) {
  const ranges: RiskRange[] = [
    { from: 0, to: 18.5, risk: Risk.Risk, label: "low" },
    { from: 30, to: 40, risk: Risk.Risk, label: "high" },
  ];

  if (age >= 70) {
    ranges.push(
      { from: 22, to: 40, risk: Risk.Normal, label: "normal" },
      { from: 0, to: 22, risk: Risk.Risk, label: "low" }
    );
  } else {
    ranges.push(
      { from: 25, to: 40, risk: Risk.Risk, label: "high" },
      { from: 18.5, to: 25, risk: Risk.Normal, label: "normal" }
    );
  }

  return new RiskRanges("bmi", ranges);
}

export const BMI = {
  rangesFor,
};
